import { Directive, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { AppFlavour } from '@core/models/config/app-flavour';
import { environment } from '@environments/environment';

/**
 * Directive that adds the current app flavour as a CSS class to the host element.
 * 
 * Usage:
 * ```html
 * <div payAppFlavourClass>...</div>
 * ```
 * 
 * This will add the flavour (e.g., 'default' or 'shift4') as a class to the element,
 * allowing CSS to target flavour-specific styles:
 * ```scss
 * .my-component {
 *   &.shift4 {
 *     // shift4-specific styles
 *   }
 * }
 * ```
 */
@Directive({
    selector: '[payAppFlavourClass]',
    standalone: true
})
export class AppFlavourClassDirective implements OnInit {
    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2
    ) {}

    ngOnInit(): void {
        // Only add class for non-default flavours
        if (environment.flavour && environment.flavour !== AppFlavour.DEFAULT) {
            this.renderer.addClass(this.elementRef.nativeElement, environment.flavour);
        }
    }
}
